/** `pluralize(1, 'cap')` → `'1 cap'`, `pluralize(2, 'cap')` → `'2 caps'`. Pass `plural` for irregular nouns. */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`
}
